import {
  useContext, useEffect, useMemo, type ReactNode,
} from "react";
import { createRoutesFromChildren, useLocation, useRoutes } from "react-router";
import { getRoutePattern } from "@/shared/services/usageTracking/routePattern";
import { UsageTrackingContext } from "./UsageTrackingContext";

/**
 * Drop-in replacement for `<Routes>` that also reports the matched route
 * template as a page view (no-op outside `UsageTrackingProvider`).
 */
const TrackedRoutes = ({ children }: { children: ReactNode }) => {
  const trackView = useContext(UsageTrackingContext);
  const routes = useMemo(() => createRoutesFromChildren(children), [children]);
  const { pathname } = useLocation();
  const page = useMemo(() => getRoutePattern(routes, pathname), [routes, pathname]);

  useEffect(() => {
    if (page) trackView?.(page);
  }, [page, trackView]);

  return useRoutes(routes);
};

export default TrackedRoutes;
